import {createRouter,createWebHistory} from 'vue-router'
import { useOAuthStore } from "@/stores/oauth";

import HomePage from "./views/HomePage.vue"
import UserAuth from "./views/UserAuth.vue"
import ArticleDetail from "./views/ArticleDetail.vue"
import UserInfo from "./views/UserInfo.vue"
import AuthRedirect from "./views/AuthRedirect.vue"
import OAuthGithub from "./views/OAuthGithub.vue"
import CreatorHome from "./views/creator/CreatorHome.vue"
import ContentArticle from "./views/creator/ContentArticle.vue"
import EditorDrafts from "./views/editor/EditorDrafts.vue"
import CreateDrafts from "./views/editor/CreateDrafts.vue"
import ArticlePublished from "./views/ArticlePublished.vue"
import NotFoundView from "./views/NotFoundView.vue"
import UserAvatar from "./views/user/UserAvatar.vue"
import UserProfile from "./views/user/UserProfile.vue"

import AboutMe from "./views/about/AboutMe.vue"
import ArticleReviewList from "./views/postreview/ArticleReviewList.vue"
import PostReviewAction from "./views/postreview/PostReviewAction.vue"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: HomePage },
    { path: '/user_auth', component: UserAuth, meta: { requireAuth: false } },
    { path: '/post/:postID', component: ArticleDetail, meta: { requireAuth: false } },
    { path: '/user/:userID', component: UserInfo, meta: { requireAuth: false } },
    { path: '/oauth/redirect', component: AuthRedirect, meta: { requireAuth: false } },
    { path: '/oauth/githubcallback', component: OAuthGithub, meta: { requireAuth: false }},
    { path: '/creator/home', component: CreatorHome, meta: { requireAuth: true } },
    { path: '/creator/article', component: ContentArticle, meta: { requireAuth: true } },
    { path: '/editor/drafts/:postID', component: EditorDrafts, meta: { requireAuth: true } },
    { path: '/editor/create/drafts', component: CreateDrafts, meta: { requireAuth: true } },
    { path: '/published', component: ArticlePublished, meta: { requireAuth: true } },
    { path: '/:pathMatch(.*)*', component: NotFoundView },
    { path: '/user/settings/avatar', component: UserAvatar, meta: { requireAuth: true } },
    { path: '/user/settings/profile', component: UserProfile, meta: { requireAuth: true } },
    { path: '/about', component: AboutMe, meta: { requireAuth: false } },
    { path: '/creator/postreview', component: ArticleReviewList, meta: { requireAuth: true } },
    { path: '/postreview/article/:postID', component: PostReviewAction, meta: { requireAuth: true } },
  ],
})

// 添加路由守卫
router.beforeEach((to, from, next) => {

  const isAuthRequired = to.meta.requireAuth; // 明确类型为 boolean | undefined
  const authStore = useOAuthStore();
  if (isAuthRequired) {
    if (authStore.token) {
      next(); // 有 token，放行
    } else {
      //next('/'); // 无 token，跳转到首页
      next({
        path: "/",
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next(); // 不需要认证，直接放行
  }
});

export default router